import { combineEpics } from 'redux-observable';

import { findDailySalesEpic } from './FindDailySales/FindDailySalesEpic';
import { findMauDauWauEpic }  from './FindMauDauWau/FindMauDauWauEpic';

export const salesEpics = combineEpics(
  findDailySalesEpic,
  findMauDauWauEpic,
);
